import React from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

// Bright, playful palette. The text uses each vivid color; the card background
// is a lighter tint of that same color. Categories cycle through these.
const PALETTE = [
    '#E8590C', // orange
    '#D49500', // yellow
    '#1FA85C', // green
    '#E0317B', // pink
    '#1C8FB5', // sky
    '#6FA01E', // lime
    '#6B4BFF', // purple
    '#E8870C', // amber
]

// Lighten a hex color by mixing it toward white (amount 0..1).
const tint = (hex, amount) => {
    const n = parseInt(hex.slice(1), 16)
    const mix = (c) => Math.round(c + (255 - c) * amount)
    return `rgb(${mix((n >> 16) & 255)}, ${mix((n >> 8) & 255)}, ${mix(n & 255)})`
}

const responsive = {
    superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 6 },
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 6 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 4 },
    mdtablet: { breakpoint: { max: 991, min: 464 }, items: 4 },
    mobile: { breakpoint: { max: 768, min: 0 }, items: 3 },
    smmobile: { breakpoint: { max: 640, min: 0 }, items: 2 },
    xsmobile: { breakpoint: { max: 440, min: 0 }, items: 2 },
}

const CategoryCard = ({ name, index }) => {
    const color = PALETTE[index % PALETTE.length]
    // Stack each word on its own line so the name reads like a tight wordmark.
    const words = String(name).trim().split(/\s+/)
    const fontSize =
        words.length >= 3 ? 'clamp(1.5rem, 5vw, 1.8rem)' :
        words.length === 2 ? 'clamp(1.8rem, 6vw, 2.2rem)' :
        'clamp(2rem, 7vw, 2.6rem)'

    return (
        <div
            className='flex h-full w-full items-center justify-center rounded-[18px] p-3 text-center transition-transform duration-300 ease-out hover:-translate-y-1'
            style={{ backgroundColor: tint(color, 0.68), color }}
        >
            <h3
                style={{
                    fontFamily: "'Baloo 2', cursive",
                    fontWeight: 800,
                    fontSize,
                    lineHeight: 1,
                    letterSpacing: '-0.01em',
                    textWrap: 'balance',
                    wordBreak: 'break-word',
                }}
            >
                {words.map((w, i) => (
                    <span key={i} className='block'>{w}</span>
                ))}
            </h3>
        </div>
    )
}

const Categorys = () => {
    const { categorys } = useSelector(state => state.home)

    return (
        <div className='w-[86%] sm:w-[95%] mx-auto relative'>
            <Carousel
                autoPlay={true}
                infinite={true}
                arrows={true}
                responsive={responsive}
                transitionDuration={500}
            >
                {categorys.map((c, i) => (
                    <Link
                        key={c._id || i}
                        to={`/products?category=${encodeURIComponent(c.name)}`}
                        className='block h-[130px] xs:h-[115px] p-2 sm:p-1'
                    >
                        <CategoryCard name={c.name} index={i} />
                    </Link>
                ))}
            </Carousel>
        </div>
    )
}

export default Categorys
